<p-dialog
    class="without-close" [breakpoints]="{ '960px': '60vw', '560px': '90vw' }"
    [visible]="modalService.visible$ | async" [draggable]="false" [resizable]="false"
    [style]="{ maxWidth: '25vw', minWidth: '25rem' }" [modal]="true" [closeOnEscape]="false" [closable]="false">
    <ng-container *ngIf="modalService.config$ | async as config">
        <div class="flex flex-col justify-center text-center items-center gap-5">
            <ng-container [ngSwitch]="config.icon">
                <i *ngSwitchCase="'warning'" class="pi pi-exclamation-circle" style="color: #e0bd2e; font-size: 4rem"></i>
                <i *ngSwitchCase="'info'" class="pi pi-info-circle" style="color: #0c549c; font-size: 4rem"></i>
                <i *ngSwitchCase="'error'" class="pi pi-times-circle" style="color: #dc2626; font-size: 4rem"></i>
                <i *ngSwitchCase="'success'" class="pi pi-check-circle" style="color: #2aa711; font-size: 4rem"></i>
            </ng-container>

            <div class="flex flex-col justify-center text-center items-center gap-1">
                <h2 class="text-xl font-semibold">
                    {{config.title}}
                </h2>
                <p class="text-[14px]">
                    {{config.message}}
                </p>
            </div>

            <div class="flex flex-col justify-center md:flex-row gap-3">
                <p-button *ngIf="config.showCancel" [label]="config.cancelText || 'Cancel'" styleClass="p-button-outlined" (click)="modalService.cancel()"></p-button>
                <p-button [label]="config.confirmText || 'OK'" (click)="modalService.confirm()"></p-button>
            </div>

        </div>
    </ng-container>
</p-dialog>